import ListingUrlParser from './parsers/ListingUrlParser';

/**
 * Parses listing page URLs
 *
 * @example
 * parseURL(
 *      '/vacation-rental/p4587083?uni_id=5239115'
 * );
 * // returns
 * // {
 * //   baseUrl: '/vacation-rental/p4587083',
 * //   uni_id: '5239115'
 * // }
 *
 * @param {string} url - listing page url
 * @returns {object} listingRequest - corresponding to the given listing page URL
 */
export default function parseURL(url) {
    const parser = new ListingUrlParser();
    let listingRequest = {};

    try {
        const decodedUrl = decodeURI(url);
        listingRequest = parser.parse(decodedUrl);
    } catch (e) {
        throw new Error(`Error on decoding listing URL ${e}`);
    }

    return listingRequest;
}
